/* eslint-disable */
export default {
  title: '지역',
  NAOnlyMessage: '지역 코드를 설정하세요. 이는 지역 전화 걸기에 사용됩니다.',
  MultiWithNAMessage:
    '사용자 지역의 국가 및 지역 코드를 설정하세요. 이는 지역 전화 걸기와 전화번호 서식에 사용됩니다.',
  MultiWithoutNAMessage:
    '사용자가 있는 국가를 선택하세요. 이는 지역 전화 걸기와 전화번호 서식에 사용됩니다.',
  country: '국가',
  areaCode: '지역 코드',
  areaCodePlaceholder: '지역 코드 입력',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
